import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {SurveyCreatorModel} from "survey-creator-core";
import {Subject, takeUntil} from "rxjs";
import {Store} from "@ngrx/store";
import {fetchEditSurveyQuestionnairesDetails} from "../../core/questionnaires.selectors";
import {EditSurveyDataForEditScreenRequest} from "../../core/questionnaires.actions";
import {QuestionnaireDetails} from "../../models/fetch-questionnaires-list.model";
import {QuestionnaireConstant} from '../../constants/questionnaire.enum';

@Component({
  selector: 'app-edit-questionnaire',
  templateUrl: './edit-questionnaire.component.html',
  styleUrls: ['./edit-questionnaire.component.css']
})
export class EditQuestionnaireComponent implements OnInit, OnDestroy {

  @Input() surveyId: string = '';
  @Input() loggedInUserRole: number = null;
  @Input() clientId: string = ''
  @Input() groupId: string = ''
  editMode: boolean = false;
  creatorOptions = {
    showLogicTab: false,
    isAutoSave: true,
    showJSONEditorTab: false,
    allowModifyPages: false,
    questionTypes: ["text", "checkbox", "dropdown", "comment", "tagbox"],
    showThemeTab: true,
    showSurveyTitle: false,
  };
  surveyCreatorModel: SurveyCreatorModel;
  loading: boolean = false;
  formData: any = {};
  surveyDetails: QuestionnaireDetails;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(private store: Store) {
  }

  ngOnInit(): void {
    this.store.select(fetchEditSurveyQuestionnairesDetails)
      .pipe(takeUntil(this.onDestroy)).subscribe(questionnairesDetails => {
      if (Object.keys(questionnairesDetails.details).length !== 0) {
        this.loading = questionnairesDetails?.loading
        this.surveyDetails = questionnairesDetails?.details
        this.formData = questionnairesDetails?.details?.config[0]
      }
    })
  }

  createCreateSurveyForm() {
    const creator = new SurveyCreatorModel(this.creatorOptions);
    creator.text = JSON.stringify(this.formData)
    this.surveyCreatorModel = creator;
  }

  onEditButtonClicked() {
    if (this.editMode) {
      const updatedElements = this.surveyCreatorModel.JSON.pages[0].elements.map(item => {
        if (item.inputType === 'url') {
          return {
            ...item,
            validators: [
              {
                type: "regex",
                regex: "^(?:http|https)://",
                text: "Please provide a valid url",
              },
            ],
          }
        } else {
          return {
            ...item
          }
        }
      })
      const updatedSurveyData = [
        {
          name: 'page1',
          elements: updatedElements,
          checkErrorsMode: "onValueChanged",
        }
      ]
      this.formData = {...updatedSurveyData[0]}
    }
    this.editMode = !this.editMode;
    if (this.editMode) {
      this.createCreateSurveyForm();
    } else if (!this.editMode) {
      const configData: any[] = []
      configData.push(this.formData)
      this.store.dispatch(EditSurveyDataForEditScreenRequest({
        payload: {surveyDetails: {id: +this.surveyId, config: configData, status: QuestionnaireConstant.openStatus}}
      }))
    }
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
